import { render, staticRenderFns } from "./editorjs.vue?vue&type=template&id=60b5a97c"
import script from "./editorjs.vue?vue&type=script&lang=js"
export * from "./editorjs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports